@use "styles" as *;

.me-pager {
  display: flex;
  justify-content: center;
  align-items: stretch;
}
